import * as React from 'react';
import { SVGProps } from 'react';

const FileIconCsvSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={24} height={28} rx={2} />
    <path
      opacity={0.5}
      d="M18 20h-3v2h3v-2ZM6 20v2h3v-2H6Zm4 0v2h4v-2h-4Zm8-1v-2h-3v2h3ZM6 19h3v-2H6v2Zm4 0h4v-2h-4v2Zm8-3v-2H6v2h3v-2h1v2h4v-2h1v2h3ZM5 13h14v10H5V13Z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.7 9c-.587 0-1.017-.123-1.29-.37C6.137 8.377 6 7.967 6 7.4V5.6c0-.56.137-.967.41-1.22.28-.253.71-.38 1.29-.38h1.29v1H7.74c-.247 0-.433.057-.56.17-.127.113-.19.273-.19.48v1.7c0 .207.063.367.19.48.127.113.313.17.56.17h1.25v1H7.7ZM14 4h1v3h1V4h1v3l-1 2h-1l-1-2V4Zm-1.39 4.69c.26-.207.39-.52.39-.94V7.3c0-.427-.117-.747-.35-.96-.233-.22-.573-.34-1.02-.34h-.15a.544.544 0 0 1-.35-.1c-.087-.073-.13-.187-.13-.34v-.11c0-.147.05-.257.15-.33.1-.08.233-.12.4-.12H13V4h-1.5c-.493 0-.907.1-1.16.3-.253.193-.34.513-.34.96v.47c0 .44.073.763.3.97.233.2.433.3.9.3h.37c.287 0 .43.15.43.45v.1c0 .147-.047.26-.14.34-.093.073-.23.11-.41.11H10v1h1.5c.487 0 .857-.103 1.11-.31Z"
      fill="#fff"
    />
  </svg>
);
export default FileIconCsvSizeS;
